module.exports = __webpack_public_path__ + "../front_assets/img/portuguese.939aca55.png";